import { formatNumbers, LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'

import { Bar } from 'views/ReduceEmissions/Bar'

type EmissionsByCarrier = {
    carrier: string
    totalTeu: number
    totalEmissions: number
    carbonIntensity: number
}

const { palette } = LuneThemeNew

export const RouterAndCarrierChart = ({
    data,
    highestCarrierByTeu,
    highestCarrierByEmissions,
}: {
    highestCarrierByTeu: number
    highestCarrierByEmissions: number
    data: {
        totalLegs: number
        emissionsByCarrier: Array<EmissionsByCarrier>
    }
}) => {
    const { emissionsByCarrier } = data

    return (
        <Box
            sx={{
                boxSizing: 'borderBox',
                '*': {
                    boxSizing: 'borderBox',
                },
            }}
        >
            {emissionsByCarrier.map((e, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        gap: 3,
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        '> div': {
                            pt: 1,
                            pb: 1,
                            display: 'flex',
                            alignItems: 'center',
                            overflow: 'hidden',
                            '&:nth-child(1)': {
                                width: '32%',
                                justifyContent: 'flex-end',
                            },
                            '&:nth-child(2)': {
                                width: '18%',
                                justifyContent: 'center',
                            },
                            '&:nth-child(3)': {
                                width: '32%',
                            },
                            '&:nth-child(4)': {
                                width: '18%',
                                justifyContent: 'flex-end',
                            },
                        },
                    }}
                >
                    <Box>
                        <Bar
                            value={e.totalTeu}
                            maxValue={highestCarrierByTeu}
                            color={palette.Data1200}
                            alignRight={true}
                        />
                    </Box>
                    <Box>
                        <Text
                            variant={'body3'}
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {e.carrier}
                        </Text>
                    </Box>
                    <Box>
                        <Bar
                            value={e.totalEmissions}
                            maxValue={highestCarrierByEmissions}
                            color={palette.Data100}
                        />
                    </Box>
                    <Box>
                        <Text variant={'body3'}>
                            {formatNumbers(Math.round(e.carbonIntensity))} gCO₂e/TEU-km
                        </Text>
                    </Box>
                </Box>
            ))}
        </Box>
    )
}
